import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const LOADING_PAYMENT_ROWS = 3

const SkeletonLoader = () => {
  return (
    <Box paddingY="s40" gap="s8">
      <Box width="full" gap="s8" flexDirection="row" justifyContent="spaceBetween">
        <Skeleton height="s16" width="s120" />
        <Skeleton height="s16" width="s120" />
      </Box>

      <Box
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs006',
        }}
      >
        {Array(LOADING_PAYMENT_ROWS)
          .fill(0)
          .map((item, index) => {
            return (
              <Box
                key={index}
                height="s64"
                padding="s16"
                border={{
                  top: { width: 's1', style: 'solid', color: 'grey400' },
                }}
                justifyContent="center"
                cursor="pointer"
              >
                <Box
                  alignItems="center"
                  justifyContent="spaceBetween"
                  width="full"
                  flexDirection="row"
                >
                  <Skeleton height="s12" width="s140" />
                  <Skeleton height="s12" width="s200" />
                  <Skeleton height="s12" width="s240" />
                  <Skeleton height="s12" width="s140" />
                </Box>
              </Box>
            )
          })}
      </Box>
    </Box>
  )
}

export default SkeletonLoader
